import * as types from './GSAction_Type'
const initialState = {
  bookingConsType: [],
  paymentModeTableData: [],
  methodOfPkngTblData: [],
  pickUpAndDropoff: [],
  focApprTblData: [],
  focApprConsTypeData: [],
  gsDocumentsCharge: {},
  gsValuationChargeTableData: {},
  gsValuationChargeEditData: {},
  autoDeliveryTblData: [],
  autoReceiveTableData: [],
  autoBrnchTransRecvTblData: [],
  autoBrnchTransRecvFilters: [],
  monthlyTargetTableData: [],
  gstValidationData: {},
  gstInvoiceConfigData: {},
  labelList: [],
  ticketFormatList: [],
  partyConfigTableData:[],
  methodOfPkngTblData:[],
  destCityWithCrossingBranchTableData:[],
  crossingCities:[],
  serviceTypeListAllTableData:[],
  serviceTypeListAll:[],
  serviceTypeListAll2:[],
  kgKmRateMatrixData:{},
  kgKmRateMatrixHistoryData:[],
  kgKmDocChrgData:[],
  cargoCityListData:[],
  partyMarsterAllData:[],
}
const generalSettingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.BOOKING_CONS_TYPE:
      return { ...state, bookingConsType: action.data }
    case types.PAYMENT_MODE_TABLEDATA:
      return { ...state, paymentModeTableData: action.data }
    case types.FOC_APPR_LIST:
      return { ...state, focApprTblData: action.data }
    case types.FOC_APPR_CONS_TYPE_DATA:
      return { ...state, focApprConsTypeData: action.data }
    case types.PICKUP_AND_DROPOFF:
      return { ...state, pickUpAndDropoff: action.data }
    case types.GS_DOCUMENTS_CHARGE:
      return { ...state, gsDocumentsCharge: action.data }
    case types.GS_VALUATION_CHARGE_TABLE:
      return { ...state, gsValuationChargeTableData: action.data }
    case types.GS_EDIT_VALUATION_CHARGE_DETAIL:
      return { ...state, gsValuationChargeEditData: action.data }
    case types.MOP_TBL_DATA:
      return { ...state, methodOfPkngTblData: action.data }
    case types.AUTO_Del_TBL_DATA:
      return { ...state, autoDeliveryTblData: action.data }
    case types.AUTO_RECEIVE_TBL_DATA:
      return { ...state, autoReceiveTableData: action.data }
    case types.AUTO_BRNCH_TRANS_RECV_TBL_DATA:
      return { ...state, autoBrnchTransRecvTblData: action.data }
    case types.AUTO_BRNCH_TRANS_RECV_FILTERS:
      return { ...state, autoBrnchTransRecvFilters: action.data }
    case types.MONTHLY_TARGET_TABLE_DATA:
      return { ...state, monthlyTargetTableData: action.data }
    case types.GST_VALIDATION_DATA:
      return { ...state, gstValidationData: action.data }
    case types.GST_INV_CONFIG_DATA:
      return { ...state, gstInvoiceConfigData: action.data }
    case types.Label_LIST:
      return { ...state, labelList: action.data }
    case types.TICKET_FORMAT_LIST:
      return { ...state, ticketFormatList: action.data }
    case types.PARTY_CONFIG_TBL_DATA:
      return { ...state, partyConfigTableData: action.data }
    case types.DESTCITY_WITH_CROSSING_BRANCH:
      return { ...state, destCityWithCrossingBranchTableData: action.data }
    case types.CITY_LIST_F0R_CROSSING_MASTER:
      return { ...state, crossingCities: action.data }
    case types.SERVICE_TYPE_LIST_ALL_TABLE_DATA:
      return { ...state, serviceTypeListAllTableData: action.data }
    case types.SERVICE_TYPE_LIST_ALL_DATA:
      return { ...state, serviceTypeListAll: action.data }
    case types.SERVICE_TYPE_LIST_ALL2_DATA:
      return { ...state, serviceTypeListAll2: action.data }
    case types.KG_KM_RATE_MATRIX_DATA:
      return { ...state, kgKmRateMatrixData: action.data }
    case types.KG_KM_RATE_MATRIX_HISTORY_DATA:
      return { ...state, kgKmRateMatrixHistoryData: action.data }
    case types.KG_KM_DOC_CHRG_DATA:
      return { ...state, kgKmDocChrgData: action.data }
    case types.CARGO_CITY_LIST:
      return { ...state, cargoCityListData: action.data }
    case types.PARTY_MASTER_LIST_ALL:
      return { ...state, partyMarsterAllData: action.data }
    default:
      return state
  }
}
export default generalSettingReducer
